import { render, staticRenderFns } from "./FeedbackEdit.vue?vue&type=template&id=023c2ba2&scoped=true&"
import script from "@/scripts/QA/Question/components/Feedback/FeedbackEdit?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/Feedback/FeedbackEdit?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c2ba2",
  null
  
)

export default component.exports